// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Certificado_hidden__OA7f0","form":"Certificado_form__2nN3j","content":"Certificado_content__1E17i","link":"Certificado_link__23yo3"};